"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_query_1 = require("react-query");
var button_component_1 = require("../../../common/buttons/button_component");
var drop_down_component_1 = require("../../../common/drop_down/drop_down_component");
var react_paginate_1 = require("../../../common/react_pagination/react_paginate");
var search_component_1 = require("../../../common/search/search_component");
var AGgrid_table_component_1 = require("../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../constants/appConstants");
var table_data_1 = require("../../../constants/table_data");
var menu_constants_1 = require("../../../menuList/menu_constants");
var array_helpers_1 = require("../../../utils/array_helpers");
var Create_User_Logistics_1 = require("./Create_User_Logistics");
var user_logistics_api_1 = require("./user_logistics_api");
var material_1 = require("@mui/material");
var formik_1 = require("formik");
var schema_1 = require("../../../constants/schema");
var pop_up_1 = require("../../../common/modal/pop-up");
var iconButton_component_1 = require("../../../common/buttons/iconButton_component");
var UserLogisticsList = function (_a) {
    var _b = React.useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = React.useState(false), openPop = _c[0], setOpenPop = _c[1];
    var _d = React.useState(false), assignRegion = _d[0], setAssignRegion = _d[1];
    var _e = React.useState(appConstants_1.defaultPageLimit), PageLimit = _e[0], setPageLimit = _e[1];
    var searchFe = function (event) {
        setSearchTerm(event.target.value.trim());
    };
    var popUpOpen = function () {
        setOpenPop(true);
    };
    var _f = React.useState(undefined), dataList = _f[0], setDataList = _f[1];
    var _g = React.useState([]), allTempList = _g[0], setAllTempList = _g[1];
    var _h = React.useState([]), alluserList = _h[0], setAllUserList = _h[1];
    var _j = React.useState([]), targetUserList = _j[0], setTargetUserList = _j[1];
    var _k = React.useState(1), pageCount = _k[0], setpageCount = _k[1];
    var _l = React.useState(false), pageReload = _l[0], setPageReload = _l[1];
    var _m = React.useState(0), totalPageCount = _m[0], setTotalPageCount = _m[1];
    var UpdateListData = React.useContext(appConstants_1.ReloadListContext);
    var _o = React.useState(0), totalCount = _o[0], setTotalCount = _o[1];
    var _p = React.useState(false), filterButton = _p[0], setFilterbutton = _p[1];
    var _q = React.useState(''), errorMessage = _q[0], setErrorMessage = _q[1];
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.Admin_User_Management);
    var refetch = (0, react_query_1.useQuery)(['active-fe', pageCount], function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = {};
        if (searchTerm.trim().length >= 3) {
            payload.search_string = searchTerm.trim();
        }
        payload.page = currentPage;
        payload.size = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        (0, user_logistics_api_1.fetchUserLogisticsList)(payload)
            .then(function (response) {
            var pageSize = PageLimit
                ? parseInt(PageLimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setTotalPageCount(count);
            var convertedData = (0, array_helpers_1.convertUserLogisticsListFromRes)(response === null || response === void 0 ? void 0 : response.result);
            setAllTempList(response === null || response === void 0 ? void 0 : response.result);
            setDataList(convertedData);
            UpdateListData.setIsListReloaded(false);
            setTotalCount(response.count);
        })
            .catch(function (err) {
            setErrorMessage(err.message);
            react_hot_toast_1.default.error(err.message);
            setDataList([]);
        });
    }).refetch;
    var submitHandler = function (values) {
        var payload = {
            user_id: values.copied_user_id.id,
            new_user_id: values.target_fe_id.id
        };
        (0, user_logistics_api_1.submitCopiedRegions)(payload);
    };
    var fetchAllUsers = function () {
        setAssignRegion(true);
        var convertedUserResponse = (0, array_helpers_1.convertAllUserListResponse)(allTempList);
        setAllUserList(convertedUserResponse);
    };
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [filterButton, pageReload]);
    var handlePageLimitChange = function (val) {
        setPageLimit(val);
    };
    var FilterHandler = function () {
        setFilterbutton(!filterButton);
    };
    return (React.createElement("div", { className: "fe-wrapper page-wrapper fe-mangamnet-wrapper" },
        React.createElement("div", { className: "tool-bar-wrapper" },
            React.createElement("div", { className: "page-heaidng" },
                React.createElement("h2", null, "Admin User")),
            React.createElement("div", { className: "page-control-wrapper" },
                React.createElement("div", { className: "page-control-wrapper" },
                    React.createElement(button_component_1.default, { buttonName: "Assign Region", color: "yellow-outline", onClickHandler: fetchAllUsers }),
                    React.createElement(button_component_1.default, { buttonName: "ADD User", color: "yellow", onClickHandler: popUpOpen, isError: !features[menu_constants_1.FEATURE_CONSTANTS.adminUserCreate] })),
                React.createElement(Create_User_Logistics_1.default, { openPopToAdd: openPop, setPopToAdd: setOpenPop, setPageload: setPageReload }))),
        React.createElement("div", { className: "filter-menu-wrapper" },
            React.createElement("div", { className: "search-filter search-lg" },
                React.createElement(search_component_1.default, { placeholder: "Search by Name, EMail, Mobile", searchValue: searchTerm, searchHandler: searchFe })),
            React.createElement("div", { className: "filter-options" },
                React.createElement(drop_down_component_1.default, { dropDownList: appConstants_1.paginationDropdown, onChange: handlePageLimitChange, value: PageLimit }),
                React.createElement(button_component_1.default, { buttonName: "FILTERS", color: "yellow-outline", onClickHandler: FilterHandler }))),
        React.createElement("div", { className: "unclickablerow" },
            React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.USER_LOGISTICS_LIST, rows: dataList && dataList, errorMessage: errorMessage, pagination: false, className: 'admin-user-table' }),
            React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: dataList === null || dataList === void 0 ? void 0 : dataList.length, currentPageLimits: PageLimit === null || PageLimit === void 0 ? void 0 : PageLimit.value })),
        React.createElement(pop_up_1.default, { open: assignRegion, popUpSize: "popup-lg" },
            React.createElement("div", { className: "modal-header header-wrapper" },
                React.createElement("h2", { className: "heading" }, "Region Transfer"),
                React.createElement("h2", { className: "sub-heading" }, "This feature will assign the regions of one user to another user.")),
            React.createElement(formik_1.Formik, { initialValues: {
                    copied_user_id: '',
                    target_fe_id: ''
                }, validateOnBlur: false, onSubmit: submitHandler, validationSchema: schema_1.schemas.User_Region_Copy }, function (_a) {
                var values = _a.values, errors = _a.errors, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched, touched = _a.touched;
                return (React.createElement(formik_1.Form, { className: "input-fileds-wrapper" },
                    React.createElement("div", { className: "modal-body" },
                        React.createElement("div", { className: "grey-bg-conatiner swap-input-filed" },
                            React.createElement("div", { className: "input-fileds-wrapper" },
                                React.createElement("div", { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' } },
                                    React.createElement("h2", { className: "sub-heading" }, "Please select a user to copy the regions"),
                                    React.createElement("h2", { className: "sub-heading" }, "Please select a user to assign the copied regions")),
                                React.createElement(material_1.Grid, { container: true, columns: { xs: 11 }, columnSpacing: 3, alignItems: 'center' },
                                    React.createElement(material_1.Grid, { item: true, xs: 5 },
                                        React.createElement(drop_down_component_1.default, { noOptionsText: "User's Not Found", dropDownList: alluserList.length > 0 ? alluserList : [], placeholder: "From User", onChange: function (val) {
                                                setFieldValue('copied_user_id', val);
                                                setFieldTouched('copied_user_id', true);
                                                var targetUserList = alluserList.filter(function (UserDetails) { return UserDetails.id != val.id; });
                                                setTargetUserList(targetUserList);
                                            }, value: values.copied_user_id }),
                                        errors['copied_user_id'] && touched['copied_user_id'] ? (React.createElement("div", { className: "error" }, errors['copied_user_id'])) : null),
                                    React.createElement(material_1.Grid, { item: true, xs: 1, className: "swap-btn-wrapper" },
                                        React.createElement(iconButton_component_1.default, { className: "squar-btn icon-btn swap-btn", icon: "icon-left-arrow" })),
                                    React.createElement(material_1.Grid, { item: true, xs: 5 },
                                        React.createElement(drop_down_component_1.default, { noOptionsText: "User's Not Found", isDisabled: !values.copied_user_id, dropDownList: targetUserList.length > 0 ? targetUserList : [], placeholder: "Target User", onChange: function (val) {
                                                setFieldValue('target_fe_id', val);
                                                setFieldTouched('target_fe_id', true);
                                            }, value: values.target_fe_id }),
                                        errors['target_fe_id'] && touched['target_fe_id'] ? (React.createElement("div", { className: "error" }, errors['target_fe_id'])) : null))))),
                    React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                        React.createElement(button_component_1.default, { buttonName: "Close", color: "yellow-outline", onClickHandler: function () { return setAssignRegion(false); } }),
                        values.visit_transfer_type !== 'Partial Transfer' &&
                            React.createElement(button_component_1.default, { type: "submit", buttonName: "Done", color: "yellow" }))));
            }))));
};
exports.default = UserLogisticsList;
